import React, { useState, useEffect } from 'react';
import Header from '../Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx'; // Import XLSX
import { Spinner } from 'react-bootstrap'; 

const ManagerList = () => {
  const [managers, setManager] = useState([]);  // Default to an empty array for managers
  const [managerEmployees, setManagerEmployees] = useState({}); // To store employees by manager id
  const [employees, setEmployees] = useState([]); // To store all employees
  const [loading, setLoading] = useState(true); // To track loading state
  const [error, setError] = useState(null); // To track error
  const [successMessage, setSuccessMessage] = useState(null); // To track success message
  const [selectedEmployees, setSelectedEmployees] = useState({}); // To track selected employees for each manager
  const [showModal, setShowModal] = useState(false); // To handle modal visibility
  const [currentManagerId, setCurrentManagerId] = useState(null); // To track which manager's modal is open

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const managerResponse = await fetch('https://apiaksharaconnect.aksharafinalytics.in/managers');
        const employeeResponse = await fetch('https://apiaksharaconnect.aksharafinalytics.in/AssignEmp');
        
        if (!managerResponse.ok || !employeeResponse.ok) {
          throw new Error('Network response was not ok');
        }
         // Fetch manager and employee data
        const managerResult = await managerResponse.json();
        const employeeResult = await employeeResponse.json();
        
        // Set the managers and employees state
        setManager(managerResult.manager || []); // Corrected
        setEmployees(employeeResult.employee || []);
        
        // Fetch employees for each manager
        for (let manager of managerResult.manager) {
          await fetchManagerEmployees(manager.id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message); // Handle errors
      } finally {
        setLoading(false); // Set loading to false when data fetching is done
      }
    };

    fetchData(); // Call the async function to fetch data
  }, []);

  const fetchManagerEmployees = async (managerId) => {
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/employee/${managerId}`);
      const data = await response.json();
      
      console.log(`Employees for manager ${managerId}:`, data); // Debug log to check the employee data
      
      // Ensure the fetched data is an array and update the state
      setManagerEmployees((prevData) => ({
        ...prevData,
        [managerId]: Array.isArray(data) ? data : [],  // Make sure it's an array
      }));
    } catch (error) {
      console.error('Error fetching employees for manager:', error);
      setManagerEmployees((prevData) => ({
        ...prevData,
        [managerId]: [], // Fallback to an empty array if an error occurs
      }));
    }
  };




  const handleAction = (action, id) => {
    if (action === 'edit') {
      navigate(`/Manager/edit/${id}`);
    }
    if (action === 'delete') {
      const confirmDelete = window.confirm("Are you sure you want to delete this manager?");
      if (confirmDelete) {
        deleteEmployee(id);  // Call delete function when action is delete
      }
    }
  };

  const deleteEmployee = async (id) => {
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/manager_del/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),  // Pass the manager id in the request body
      });

      if (!response.ok) {
        throw new Error('Failed to delete employee');
      }

      // Remove the deleted employee from the managers list
      setManager((prevmanagers) => prevmanagers.filter((manager) => manager.id !== id));

      // Set success message
      setSuccessMessage('Employee deleted successfully!');
      setError(null); // Clear any previous errors
    } catch (error) {
      console.error("Error deleting employee:", error);
      setError('Error deleting employee');  // Handle errors
      setSuccessMessage(null); // Clear any previous success messages
    }
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(managers);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "managers");

    XLSX.writeFile(wb, "Employee_List.xlsx");
  };

  const handleEmployeeSelection = (event) => {
    const { options } = event.target;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    setSelectedEmployees((prevState) => ({
      ...prevState,
      [currentManagerId]: selectedValues, // Store selection for the current manager
    }));
  };

  const handleModalClose = () => {
    setShowModal(false); // Close the modal
    setCurrentManagerId(null); // Clear current manager id
  };

  const handleModalOpen = (id) => {
    setCurrentManagerId(id); // Set current manager's id when modal is opened
    setShowModal(true); // Open the modal
  };

  const saveSelectedEmployees = async () => {
    try {
      const selectedEmployeeIds = selectedEmployees[currentManagerId];
      if (!selectedEmployeeIds || selectedEmployeeIds.length === 0) {
        alert('Please select at least one employee');
        return;
      }

      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/emp/${currentManagerId}`, {
        method: 'POST', // Or 'PUT', depending on your backend
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          employeeIds: selectedEmployeeIds, // Send the selected employee IDs
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update selected employees');
      }

      // Set success message and close the modal
      setSuccessMessage('Selected employees updated successfully!');
      setError(null);
      setShowModal(false); // Close the modal
      window.location.reload();
    } catch (error) {
      console.error("Error saving selected employees:", error);
      setError('Error saving selected employees');
      setSuccessMessage(null);
    }
  };

  if (loading) {
    return <div className="text-center mt-5">
            <Spinner animation="border" variant="primary" />
          </div>;
  }

  return (
    <>
      <Header />
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <div className="d-flex">
            <h4 className="mb-0 me-3">Manager Management</h4>
            <button className="btn btn-primary" onClick={() => navigate('/Manager')}>
              Add Manager
            </button>
          </div>
          <div>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
        </div>
        {/* Show error or success messages */}
        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        {/* Modal for selecting employees for manager */}
        <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }} aria-hidden={!showModal}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Employees </h5>
                <button type="button" className="btn-close" onClick={handleModalClose} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <label>Employee List</label>
                <select multiple className="form-control" onChange={handleEmployeeSelection} value={selectedEmployees[currentManagerId] || []}>
                  {employees?.map((employee) => (
                    <option key={employee.id} value={employee.id}>
                      {employee.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleModalClose}>Close</button>
                <button type="button" className="btn btn-primary" onClick={saveSelectedEmployees}>Save</button>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">Manager List</div>
          <div className="card-body">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Team</th>
                  <th>Add Employee</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {managers?.length > 0 ? (
                  managers.map((manager, index) => {
                    // Safely access managerEmployees[manager.id] and join employee names
                    const team = Array.isArray(managerEmployees[manager.id])
                      ? managerEmployees[manager.id]
                          .map((employee, i) => `${employee.name}${i < managerEmployees[manager.id].length - 1 ? ',' : ''}`)  // Add comma except for the last employee
                          .join('\n') // Join with newline for each employee
                      : 'No employees'; // Display "No employees" if there are no employees

                    return (
                      <tr key={manager.id}>
                        <td>{index + 1}</td>
                        <td><a href={`/EmpInfo/${manager.id}`} className="text-decoration-none">
                          {manager.name || 'N/A'}
                        </a></td>
                        <td>{manager.email || 'N/A'}</td>
                        <td>{manager.phone || 'N/A'}</td>
                        <td style={{ whiteSpace: 'pre-line' }}>{team || 'N/A'}</td> 
                        <td>
                          <button className="btn btn-info ms-2" onClick={() => handleModalOpen(manager.id)}>
                            Add
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn btn-warning"
                            onClick={() => handleAction('edit', manager.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger ms-2"
                            onClick={() => handleAction('delete', manager.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6">No managers available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagerList;
